import { render } from "./FaceVerificationDialog.vue?vue&type=template&id=73c8e4fe&scoped=true"
import script from "./FaceVerificationDialog.vue?vue&type=script&lang=js"
export * from "./FaceVerificationDialog.vue?vue&type=script&lang=js"

import "./FaceVerificationDialog.vue?vue&type=style&index=0&id=73c8e4fe&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c8e4fe"]])

export default __exports__